/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountDocument { 
    id: string;
    requestNotes?: string;
    respond_by?: string;
    status: AccountDocument.StatusEnum;
    subtype: AccountDocument.SubtypeEnum;
    type: AccountDocument.TypeEnum;
}
export namespace AccountDocument {
    export type StatusEnum = 'requested' | 'submitted' | 'rejected' | 'verified';
    export const StatusEnum = {
        REQUESTED: 'requested' as StatusEnum,
        SUBMITTED: 'submitted' as StatusEnum,
        REJECTED: 'rejected' as StatusEnum,
        VERIFIED: 'verified' as StatusEnum
    };
    export type SubtypeEnum = 'bank_letter_voided_check' | 'ein_letter' | 'articles_of_incorp' | 'business_license' | 'utility_bill' | 'processing_statement' | 'financial_statement' | '501c3' | 't3010' | 'tax_return' | 'invoice' | 'dl_passport' | 'dl_back' | 'bank_statement' | 'signed_merchant_agreement' | 'isv_cover_sheet' | 'bank_verification' | 'bank_letter' | 'voided_check' | 'secondary_address_verification' | 'drivers_license_front' | 'drivers_license_back' | 'business_model' | 'pricing_model' | 'website' | 'shopping_cart' | 'admin_return' | 'unauthorized_return' | 'insufficient_funds_return' | 'other';
    export const SubtypeEnum = {
        BANK_LETTER_VOIDED_CHECK: 'bank_letter_voided_check' as SubtypeEnum,
        EIN_LETTER: 'ein_letter' as SubtypeEnum,
        ARTICLES_OF_INCORP: 'articles_of_incorp' as SubtypeEnum,
        BUSINESS_LICENSE: 'business_license' as SubtypeEnum,
        UTILITY_BILL: 'utility_bill' as SubtypeEnum,
        PROCESSING_STATEMENT: 'processing_statement' as SubtypeEnum,
        FINANCIAL_STATEMENT: 'financial_statement' as SubtypeEnum,
        _501C3: '501c3' as SubtypeEnum,
        T3010: 't3010' as SubtypeEnum,
        TAX_RETURN: 'tax_return' as SubtypeEnum,
        INVOICE: 'invoice' as SubtypeEnum,
        DL_PASSPORT: 'dl_passport' as SubtypeEnum,
        DL_BACK: 'dl_back' as SubtypeEnum,
        BANK_STATEMENT: 'bank_statement' as SubtypeEnum,
        SIGNED_MERCHANT_AGREEMENT: 'signed_merchant_agreement' as SubtypeEnum,
        ISV_COVER_SHEET: 'isv_cover_sheet' as SubtypeEnum,
        BANK_VERIFICATION: 'bank_verification' as SubtypeEnum,
        BANK_LETTER: 'bank_letter' as SubtypeEnum,
        VOIDED_CHECK: 'voided_check' as SubtypeEnum,
        SECONDARY_ADDRESS_VERIFICATION: 'secondary_address_verification' as SubtypeEnum,
        DRIVERS_LICENSE_FRONT: 'drivers_license_front' as SubtypeEnum,
        DRIVERS_LICENSE_BACK: 'drivers_license_back' as SubtypeEnum,
        BUSINESS_MODEL: 'business_model' as SubtypeEnum,
        PRICING_MODEL: 'pricing_model' as SubtypeEnum,
        WEBSITE: 'website' as SubtypeEnum,
        SHOPPING_CART: 'shopping_cart' as SubtypeEnum,
        ADMIN_RETURN: 'admin_return' as SubtypeEnum,
        UNAUTHORIZED_RETURN: 'unauthorized_return' as SubtypeEnum,
        INSUFFICIENT_FUNDS_RETURN: 'insufficient_funds_return' as SubtypeEnum,
        OTHER: 'other' as SubtypeEnum
    };
    export type TypeEnum = 'file' | 'written';
    export const TypeEnum = {
        FILE: 'file' as TypeEnum,
        WRITTEN: 'written' as TypeEnum
    };
}


